export default __webpack_public_path__ + "static/ghci-a22964d2d2057749265586c0a17b59b2.png";